import * as Yup from "yup";

import {
    propFieldTypes as injectionPropFieldTypes
} from "../../../../hooks/api/useInjectionProps"

import {
    fieldDataTypes as injectionFieldDataTypes,
    moduleTypes as injectionFieldModuleTypes
} from "../../../../hooks/api/useInjectionFields"

export const defaultUom = {
    id: 4,
    uomName: "纸箱",
    value: "box",
}

export const itemUoms = [
    {
        display: "unit",
        value: "UNIT",
        translation: ["UNIT"],
        isDefault: false
    },
    {
        display: "box",
        // value: "纸箱",
        value: "box",
        translation: ["BOX", "纸箱"],
        isDefault: true
    },
    {
        display: "sack",
        // value: "麻袋",
        value: "sack",
        translation: ["SACK", "麻袋"],
        isDefault: false
    },
    {
        display: "pallet",
        // value: "托盘",
        value: "pallet",
        translation: ["PALLET", "托盘"],
        isDefault: false
    },
    {
        display: "wooden",
        // value: "木箱",
        value: "wooden",
        translation: ["WOODEN", "木箱"],
        isDefault: false
    },
    {
        display: "woodenCrate",
        value: "woodenCrate",
        translation: ["WOODEN CRATE", "木架"],
        isDefault: false
    },
    {
        display: "long",
        // value: "长件",
        value: "long",
        translation: ["LONG", "长件"],
        isDefault: false
    }
]

const defCustomInjectionFields = { ref: injectionFieldModuleTypes.item.item.ref, module: injectionFieldModuleTypes.item.item.module }

export const customInjectionFields = {

    packQty: { submitKey: "pack_qty", retrieveKey: "inf_itm_itm_pack_qty", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },
    handleQty: { submitKey: "handle_qty", retrieveKey: "inf_itm_itm_handle_qty", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },
    qtyPerPackage: { submitKey: "qty_per_package", retrieveKey: "inf_itm_itm_qty_per_package", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },
    totalValue: { submitKey: "total_value", retrieveKey: "inf_itm_itm_total_value", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },
    totalWeight: { submitKey: "total_weight", retrieveKey: "inf_itm_itm_total_weight", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },

    totalCbm: { submitKey: "total_cbm", retrieveKey: "inf_itm_itm_total_cbm", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },
    containerId: { submitKey: "container_id", retrieveKey: "inf_itm_itm_container_id", fieldDataTypeId: injectionFieldDataTypes.id.id, ...defCustomInjectionFields },
    locationId: { submitKey: "location_id", retrieveKey: "inf_itm_itm_location_id", fieldDataTypeId: injectionFieldDataTypes.id.id, ...defCustomInjectionFields },
    customerMarking: { submitKey: "customer_marking", retrieveKey: "inf_itm_itm_customer_marking", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    customerBranchId: { submitKey: "customer_branchid", retrieveKey: "inf_itm_itm_customer_branchid", fieldDataTypeId: injectionFieldDataTypes.id.id, ...defCustomInjectionFields },

    customerUserId: { submitKey: "customer_userid", retrieveKey: "inf_itm_itm_customer_userid", fieldDataTypeId: injectionFieldDataTypes.id.id, ...defCustomInjectionFields },
    website: { submitKey: "website", retrieveKey: "inf_itm_itm_website", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    uomName: { submitKey: "uom_name", retrieveKey: "inf_itm_itm_uom_name", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    sourceItemRemId: { submitKey: "source_item_remid", retrieveKey: "inf_itm_itm_source_item_remid", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },

}

export const customInjectionPropsBk = {
    packQty: {
        submitKey: "pack_qty",
        retrieveKey: "inj_itm_itm_pack_qty",
        propFieldId: injectionPropFieldTypes.numeric.id,
        propFieldName: injectionPropFieldTypes.numeric.fieldName,
        getValue: (val) => {
            return val
        }
    },
    handleQty: {
        submitKey: "handle_qty",
        retrieveKey: "inj_itm_itm_handle_qty",
        propFieldId: injectionPropFieldTypes.numeric.id,
        propFieldName: injectionPropFieldTypes.numeric.fieldName,
        getValue: (val) => {
            return val
        }
    },
    qtyPerPackage: {
        submitKey: "qty_per_package",
        retrieveKey: "inj_itm_itm_qty_per_package",
        propFieldId: injectionPropFieldTypes.numeric.id,
        propFieldName: injectionPropFieldTypes.numeric.fieldName,
        getValue: (val) => {
            return val
        }
    },
    totalValue: {
        submitKey: "total_value",
        retrieveKey: "inj_itm_itm_total_value",
        propFieldId: injectionPropFieldTypes.numeric.id,
        propFieldName: injectionPropFieldTypes.numeric.fieldName,
        getValue: (val) => {
            return val
        }
    },
    totalWeight: {
        submitKey: "total_weight",
        retrieveKey: "inj_itm_itm_total_weight",
        propFieldId: injectionPropFieldTypes.numeric.id,
        propFieldName: injectionPropFieldTypes.numeric.fieldName,
        getValue: (val) => {
            return val
        }
    },
    totalCbm: {
        submitKey: "total_cbm",
        retrieveKey: "inj_itm_itm_total_cbm",
        propFieldId: injectionPropFieldTypes.numeric.id,
        propFieldName: injectionPropFieldTypes.numeric.fieldName,
        getValue: (val) => {
            return val
        }
    },

    // optional - only if the item assigned to container
    containerId: {
        submitKey: "container_id",
        retrieveKey: "inj_itm_itm_container_id",
        propFieldId: injectionPropFieldTypes.id.id,
        propFieldName: injectionPropFieldTypes.id.fieldName,
        getValue: (val) => {
            return val
        }
    },
    locationId: {
        submitKey: "location_id",
        retrieveKey: "inj_itm_itm_location_id",
        propFieldId: injectionPropFieldTypes.id.id,
        propFieldName: injectionPropFieldTypes.id.fieldName,
        getValue: (val) => {
            return val
        }
    },

    customerMarking: {
        submitKey: "customer_marking",
        retrieveKey: "inj_itm_itm_customer_marking",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },
    customerBranchId: {
        submitKey: "customer_branchid",
        retrieveKey: "inj_itm_itm_customer_branchid",
        propFieldId: injectionPropFieldTypes.id.id,
        propFieldName: injectionPropFieldTypes.id.fieldName,
        getValue: (val) => {
            return val
        }
    },
    customerUserId: {
        submitKey: "customer_userid",
        retrieveKey: "inj_itm_itm_customer_userid",
        propFieldId: injectionPropFieldTypes.id.id,
        propFieldName: injectionPropFieldTypes.id.fieldName,
        getValue: (val) => {
            return val
        }
    },
    website: {
        submitKey: "website",
        retrieveKey: "inj_itm_itm_website",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },

    uomName: {
        submitKey: "uom_name",
        retrieveKey: "inj_itm_itm_uom_name",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        getValue: (val) => {
            return val
        }
    },

    // scheduler
    sourceItemRemId: {
        submitKey: "source_item_remid",
        retrieveKey: "inj_itm_itm_source_item_remid",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        propIsMultiple: 0,
        getValue: (val) => {
            return val
        }
    },
}

// temp override this
export const customInjectionProps = customInjectionFields

export const validateSchema = Yup.object().shape({
    code: Yup
        .string()
        .required("Required"),
    description: Yup
        .string()
        .required("Required"),
    remark: Yup
        .string()
        .required("Required"),
    uomId: Yup
        .string()
        .required("Required"),
    uomPrice: Yup
        .string()
        .required("Required"),
    width: Yup
        .string()
        .required("Required"),
    length: Yup
        .string()
        .required("Required"),
    height: Yup
        .string()
        .required("Required"),
    weight: Yup
        .string()
        .required("Required"),
    qty: Yup
        .string()
        .required("Required"),
    handleQty: Yup
        .string()
        .required("Required"),
    handleQtyPerPackage: Yup
        .string()
        .required("Required"),
    cbm: Yup
        .string()
        .required("Required"),
    totalValue: Yup
        .string()
        .required("Required"),
    totalCbm: Yup
        .string()
        .required("Required"),
    totalWeight: Yup
        .string()
        .required("Required"),
})

export const initialValues = {
    // optional
    productId: "",
    productName: "",

    code: "",
    description: "-",
    remark: "-",
    uomId: "",
    uomDisplay: "",
    uomPrice: "0",
    width: 0, // "",
    length: 0, // "",
    height: 0, // "",
    weight: "0",
    qty: "0",
    handleQty: "0",
    handleQtyPerPackage: "0",
    cbm: "0",
    totalValue: "0",
    totalCbm: "0",
    totalWeight: "0",
    // customUomName: defaultUom.uomName
    customUomName: defaultUom.value
}